<aside class="conversation-window">
  <div class="chat-conversation-toolbar" (click)="openChatWindow()">
    <div class="chat-conservation-main-head-elements">
      <div class="chat-profile-with-status">
        <div class="chat-profile-with-status-container">
          <img
            class="chat-conversation-toolbar-image"
            src="{{ profile_image }}"
            onerror="this.src='../../../../assets/ic-user2.jpg'"
            alt="profile"
          />
          <div class="chat-conversation-main-head-status"></div>
        </div>
        <div class="chat-conversation-toolbar-message">Messaging</div>
      </div>
      <div>
        <div class="chat-conversation-arrow-image" *ngIf="opened">
          <img
            src="../../../../assets/down_arrow_chat.png"
            alt="down_arrow_chat"
          />
        </div>
        <div class="chat-conversation-arrow-image" *ngIf="!opened">
          <img src="../../../../assets/up_arrow_chat.png" alt="up arrow" />
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="opened">
    <div class="chat-conservation-card">
      <div class="chat-search-container">
        <div class="chat-search-section">
          <img
            class="chat-search-image-section"
            src="../../../../assets/search-global.png"
            alt="search"
          />
          <div class="chat-search-input">
            <!-- <input class="search-input" type="search" [(ngModel)]="searchAdvisor" (ngModelChange)="searchAdvisors()"
               [placeholder]="message_sender_type == 1 || message_sender_type == 2 ?
               'Search' : message_sender_type == 3 ? 'Search Advisors' : message_sender_type == 4 ? 'Search Advisor Manager' : ''" /> -->
            <input
              class="search-input"
              type="search"
              [(ngModel)]="searchAdvisor"
              (ngModelChange)="searchAdvisors()"
              [placeholder]="
                message_sender_type == 1 || message_sender_type == 2
                  ? 'Search'
                  : message_sender_type == 3
                  ? 'Search Advisors'
                  : message_sender_type == 4
                  ? 'Search Advisor Success Coach'
                  : ''
              "
            />
          </div>
          <!-- <div class="chat-search-input" *ngIf="message_sender_type == 4">
              <input class="search-input" type="search" [(ngModel)]="searchAdvisor" (ngModelChange)="searchAdvisors()"
                placeholder="Search Advisor Manager" />
            </div> -->
        </div>
      </div>

      <div class="conversation-content">
        <mat-spinner
          [diameter]="55"
          *ngIf="loading"
          class="spinner"
        ></mat-spinner>
        <div *ngIf="!loading">
          <div
            class="chat-conversation-list"
            *ngFor="let advisor of filteredData; let index = index"
            (click)="openChatParticipant(advisor, $event)"
          >
            <div class="chat-participant-image-container">
              <!-- <img class="chat-participant-image" src="{{baseDownloadUrl}}/{{advisor.profile_pic}}"
                  onerror="this.src='../../../../assets/ic-user2.jpg'" alt="profile"> -->
              <img
                class="chat-participant-image"
                src="{{ baseDownloadUrl }}/{{ advisor.profile_pic }}"
                *ngIf="advisor.profile_pic != ''"
                alt="profile"
              />
              <img
                class="chat-participant-image"
                src="../../../../assets/ic-user2.jpg"
                *ngIf="advisor.profile_pic == ''"
                alt="profile"
              />
              <div
                class="chat-list-advisor-status"
                [ngClass]="{
                  online: advisor.active_now === true,
                  offline: advisor.active_now === false
                }"
              ></div>
            </div>
            <!-- <p>---{{advisor.unseen_messages_count}}</p> -->
            <div class="chat-message-container">
              <div class="chat-messenger-container-section">
                <div class="chat-messenger-container-box">
                  <div class="chat-list-advisor-name">
                    <span class="chat-list-advisor-name-main">{{
                      advisor.full_name
                    }}</span>
                  </div>
                  <!-- <p>==={{advisor.unseen_messages_count}}===</p> -->
                  <div class="chat-list-advisor-stamp">
                    <span class="chat-list-advisor-time-stamp"
                      >{{ advisor.time_stamp | date: "MMM d, y" }}
                    </span>
                  </div>
                </div>
                <div class="chat-messenger-container-box">
                  <div class="chat-messenger-container-message">
                    <p
                      class="chat-messenger-container-message-section"
                      *ngIf="advisor.sender != ''"
                    >
                      <span class="chat-participant-name-main"
                        >{{ advisor.sender }} </span
                      >: {{ advisor.message }}
                    </p>
                  </div>
                  <div
                    *ngIf="
                      (advisor.contact_id != receivedId ||
                        !participant_window) &&
                      (advisor.contact_id != receivedId2 ||
                        !participant_window2)
                    "
                  >
                    <!-- <span class="chat-unseen-messages">{{advisor.unseen_messages_count}}</span> -->
                    <p
                      class="chat-unseen-messages"
                      *ngIf="advisor.unseen_messages_count != 0"
                    >
                      {{ advisor.unseen_messages_count }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="zero-state-data-list"
          *ngIf="availableData.length == 0 && !loading"
        >
          <p>No advisors Found</p>
        </div>
      </div>
    </div>
  </div>
</aside>

<div class="chat-windows-list">
  <div class="chat-window-members">
    <ng-container *ngFor="let participant of openParticipants; let i = index">
      <div class="chat-window" *ngIf="i == 0 && openParticipants.length == 2">
        <div class="chat-window-content" *ngIf="messages_loaded">
          <div
            class="chat-window-header"
            [ngClass]="{
              'close-conversation-chat': participant_window === false
            }"
            (click)="openParticipantWindow()"
          >
            <div class="chat-window-title-with-image">
              <div>
                <img
                  class="chat-window-participant-image"
                  src="{{ baseDownloadUrl }}/{{ participant_profile_picture }}"
                  onerror="this.src='../../../../assets/ic-user.png'"
                  alt="lN"
                />
              </div>
              <div class="chat-window-name-container">
                <span class="chat-window-participant-name">{{
                  participantName | titlecase
                }}</span>
                <span
                  class="chat-window-participant-time"
                  *ngIf="active_now == false"
                  >Last seen {{ last_seen }}</span
                >
                <div class="show-status-time">
                  <div [ngClass]="{ 'online-one': active_now === true }"></div>
                  <span class="active-now-status" *ngIf="active_now == true"
                    >Active Now</span
                  >
                </div>
              </div>
            </div>
            <div class="chat-window-header-right">
              <!-- <div class="chat-window-minimizer">
            <img *ngIf="participant_window" src="../../../../assets/down_arrow_chat.png" alt="" />
            <img *ngIf="!participant_window" src="../../../../assets/up_arrow_chat.png" alt="" />
          </div> -->
              <div class="chat-window-closer" (click)="closeChat()">
                <img
                  class="close-image-icon"
                  src="../../../../assets/chat-close.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <!--chat-window-content-->
          <div>
            <div *ngIf="participant_window">
              <div
                class="chat-window-main-content"
                #message_container
                (scroll)="onScroll($event)"
                [ngClass]="{ opened: messageContentExtender === true }"
              >
                <div class="message-spinner-container">
                  <mat-spinner
                    class="message-spinner"
                    [diameter]="30"
                    *ngIf="messageLoading"
                  ></mat-spinner>
                </div>

                <div
                  class="message-group"
                  *ngFor="let inverse of firstWindowMessages; let i = index"
                >
                  <!-- <div class="show-every-day-date">
                    <div class="show-line-in-date" *ngIf="inverse.show_timestamp == true">
                      <hr/><span class="show-differential-date">{{inverse.timestamp | date: 'd MMM, y'}}</span><hr/>
                    </div>
                  </div> -->
                  <div
                    class="show-every-day-date"
                    *ngIf="inverse.show_timestamp == true"
                  >
                    <span class="show-differential-date">{{
                      inverse.timestamp | date: "d MMM, y"
                    }}</span>
                  </div>
                  <div
                    class="chat-message"
                    [ngClass]="
                      inverse.sender === receivedId
                        ? 'left-align'
                        : 'right-align'
                    "
                  >
                    <div>
                      <span
                        class="chat-message-details"
                        *ngIf="inverse.message != ''"
                        >{{ inverse.message }}</span
                      >
                    </div>
                    <!-- <div
                        *ngIf="inverse.message == '' && inverse.media.is_available == true && inverse.media.document != ''">
                        <div class="document-line-alignment">
                          <p class="document-name-change"  [ngClass]="inverse.sender ===  receivedId2 ? 'left-doc-text':'right-doc-text'">{{splitDocument(inverse.media.document)}}</p>
                          <a [ngClass]="inverse.sender ===  receivedId ? 'left-document-align':'right-document-align'"
                            href="{{baseDownloadUrl}}/{{inverse.media.document}}">
                            <a href="{{baseDownloadUrl}}/{{inverse.media.document}}">
                              <img class="file-download-image" src="../../../../assets/ic-download-file-image.svg" />
                            </a>
                          </a>
                        </div>
                      </div> -->
                    <div
                      class="download-file-alignment"
                      [ngClass]="
                        inverse.sender === receivedId ? 'left-align' : ''
                      "
                      *ngIf="
                        inverse.message == '' &&
                        inverse.media.is_available == true &&
                        inverse.media.document != ''
                      "
                    >
                      <div class="document-line-alignment">
                        <a
                          [ngClass]="
                            inverse.sender === receivedId
                              ? 'left-document-align'
                              : 'right-document-align'
                          "
                          class="document-name-change"
                          href="{{ baseDownloadUrl }}/{{
                            inverse.media.document
                          }}"
                        >
                          <p
                            class=""
                            [ngClass]="
                              inverse.sender === receivedId
                                ? 'left-doc-text'
                                : 'right-doc-text'
                            "
                          >
                            {{ splitDocument(inverse.media.document) }}
                          </p>
                        </a>
                        <a
                          [ngClass]="
                            inverse.sender === receivedId
                              ? 'left-document-align'
                              : 'right-document-align'
                          "
                          href="{{ baseDownloadUrl }}/{{
                            inverse.media.document
                          }}"
                        >
                          <a
                            href="{{ baseDownloadUrl }}/{{
                              inverse.media.document
                            }}"
                          >
                            <img
                              class="file-download-image"
                              src="../../../../assets/ic-download-file-image.svg"
                            />
                          </a>
                        </a>
                      </div>
                    </div>
                    <div
                      *ngIf="
                        inverse.message == '' &&
                        inverse.media.is_available == true &&
                        inverse.media.chat_pic != ''
                      "
                    >
                      <!-- <a [ngClass]="inverse.sender ===  receivedId ? 'left-align':'right-align'" href="{{baseDownloadUrl}}/{{inverse.media.chat_pic}}">Download Picture {{inverse.media.chat_pic}}</a> -->
                      <a
                        href="{{ baseDownloadUrl }}/{{
                          inverse.media.chat_pic
                        }}"
                      >
                        <img
                          class="download-image"
                          src="{{ baseDownloadUrl }}/{{
                            inverse.media.chat_pic
                          }}"
                          onerror="this.src='../../../../assets/ic-user.png'"
                        />
                        <a
                          href="{{ baseDownloadUrl }}/{{
                            inverse.media.chat_pic
                          }}"
                        >
                          <img
                            class="file-download-image"
                            src="../../../../assets/ic-download-file-image.svg"
                          />
                        </a>
                      </a>
                    </div>
                    <div
                      *ngIf="
                        inverse.message == '' &&
                        inverse.media.is_available == true &&
                        inverse.media.chat_video != ''
                      "
                    >
                      <a
                        [ngClass]="
                          inverse.sender === receivedId
                            ? 'left-align'
                            : 'right-align'
                        "
                        href="{{ baseDownloadUrl }}/{{
                          inverse.media.chat_video
                        }}"
                        >{{ inverse.media.video }} Download Video
                        <a
                          href="{{ baseDownloadUrl }}/{{
                            inverse.media.chat_video
                          }}"
                        >
                          <img
                            class="file-download-image"
                            src="../../../../assets/ic-download-file-image.svg"
                          />
                        </a>
                      </a>
                    </div>
                    <div
                      class="chat-message-time-container"
                      [ngClass]="
                        inverse.sender === receivedId
                          ? 'date-left-align'
                          : 'date-right-align'
                      "
                    >
                      <p>{{ inverse.timestamp | date: "h:mm a" }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="chat-send-message-section"
                [ngClass]="{
                  'chat-change-section': messageContentExtender === true
                }"
              >
                <!-- <div class="chat-send-message-container">
              <textarea class="chat-text-area-section">

              </textarea>
            </div> -->
                <!-- <div>
              <button class="chat-send-message-container" (click)="sendMsg()">
                <img src="../../../../assets/icons8-sent-24.png"/>
              </button>
            </div> -->
                <!-- <div class="chat-up-down-container">
                <img class="chat-up-down-section" src="../../../../assets/arrow-down.png" alt="hesodande"/>
              </div> -->

                <div class="chat-message-section">
                  <div class="chat-send-message-container">
                    <textarea
                      class="chat-text-area-section"
                      [(ngModel)]="content"
                      placeholder="Type here..."
                      [ngClass]="{
                        'chat-text-area-container':
                          messageContentExtender === true
                      }"
                    ></textarea>
                    <button
                      class="chat-send-message-button"
                      (click)="messageContentExtender = !messageContentExtender"
                    >
                      <!-- <div class="chat-window-minimizer"> -->
                      <img
                        class="updownslider"
                        *ngIf="messageContentExtender"
                        src="../../../../assets/down_arrow_chat.png"
                        alt=""
                      />
                      <img
                        class="updownslider"
                        *ngIf="!messageContentExtender"
                        src="../../../../assets/up_arrow_chat.png"
                        alt=""
                      />
                      <!-- </div> -->
                    </button>
                  </div>
                </div>
              </div>
              <div class="chat-message-clarify-section">
                <div class="chat-attachment-options">
                  <div
                    class="chat-image-send-video"
                    (click)="upload_document_file.click()"
                  >
                    <input
                      type="file"
                      class="input-file"
                      accept=".txt, text/plain,.doc,.docx,.csv, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      #upload_document_file
                      (change)="sendDocFile($event)"
                    />
                    <img
                      class="chat-image-send-container"
                      src="../../../../assets/ic-document.svg"
                    />
                  </div>
                  <!-- <div class="chat-image-send-doc" (click)="upload_video_file.click()">
                      <input type="file" accept="video/mp4,video/x-m4v,video/*" class="input-file" #upload_video_file
                        (change)="sendVideoFile($event)" />
                      <img class="chat-image-send-container" src="../../../../assets/ic-video.svg" />
                    </div> -->
                  <div
                    class="chat-image-send-doc"
                    (click)="upload_picture_file.click()"
                  >
                    <input
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      class="input-file"
                      #upload_picture_file
                      (change)="sendPicFile($event)"
                    />
                    <img
                      class="chat-image-send-container"
                      src="../../../../assets/ic-picture.svg"
                    />
                  </div>
                </div>
                <div class="chat-send-message-container">
                  <button
                    class="chat-send-button"
                    [ngClass]="{ 'send-button-color': content !== '' }"
                    (click)="sendMsg()"
                  >
                    send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-window2" *ngIf="i == 1">
        <div class="chat-window-content2" *ngIf="messages_loaded2">
          <div
            class="chat-window-header"
            [ngClass]="{
              'close-conversation-chat': participant_window2 === false
            }"
            (click)="openParticipantWindow2()"
          >
            <div class="chat-window-title-with-image">
              <div>
                <img
                  class="chat-window-participant-image"
                  src="{{ baseDownloadUrl }}/{{ participant_profile_picture1 }}"
                  onerror="this.src='../../../../assets/ic-user.png'"
                  alt="lN"
                />
              </div>
              <div class="chat-window-name-container">
                <span class="chat-window-participant-name">{{
                  participantName1 | titlecase
                }}</span>
                <span
                  class="chat-window-participant-time"
                  *ngIf="active_now1 == false"
                  >Last seen {{ last_seen1 }}</span
                >
                <div class="show-status-time">
                  <div [ngClass]="{ 'online-one': active_now1 === true }"></div>
                  <span class="active-now-status" *ngIf="active_now1 == true">
                    Active Now
                  </span>
                </div>
              </div>
            </div>
            <div class="chat-window-header-right">
              <div class="chat-window-closer" (click)="closeChat2()">
                <img
                  class="close-image-icon"
                  src="../../../../assets/chat-close.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div>
            <div *ngIf="participant_window2">
              <div
                class="chat-window-main-content"
                #message_container
                (scroll)="onScroll2($event)"
                [ngClass]="{ opened: messageContentExtender2 === true }"
              >
                <div class="message-spinner-container">
                  <mat-spinner
                    class="message-spinner"
                    [diameter]="30"
                    *ngIf="messageLoading2"
                  ></mat-spinner>
                </div>
                <div
                  class="message-group"
                  *ngFor="let inverse of secondWindowMessages; let i = index"
                >
                  <div
                    class="show-every-day-date"
                    *ngIf="inverse.show_timestamp == true"
                  >
                    <span class="show-differential-date">{{
                      inverse.timestamp | date: "d MMM, y"
                    }}</span>
                  </div>
                  <div>
                    <div
                      class="chat-message"
                      [ngClass]="
                        inverse.sender === receivedId2
                          ? 'left-align'
                          : 'right-align'
                      "
                    >
                      <div>
                        <span
                          class="chat-message-details"
                          *ngIf="inverse.message != ''"
                          >{{ inverse.message }}</span
                        >
                      </div>
                      <div
                        class="download-file-alignment"
                        [ngClass]="
                          inverse.sender === receivedId2 ? 'left-align' : ''
                        "
                        *ngIf="
                          inverse.message == '' &&
                          inverse.media.is_available == true &&
                          inverse.media.document != ''
                        "
                      >
                        <div class="document-line-alignment">
                          <a
                            href="{{ baseDownloadUrl }}/{{
                              inverse.media.document
                            }}"
                            class="document-name-change"
                            [ngClass]="
                              inverse.sender === receivedId2
                                ? 'left-doc-text'
                                : 'right-doc-text'
                            "
                            >{{ splitDocument(inverse.media.document) }}</a
                          >
                          <a
                            [ngClass]="
                              inverse.sender === receivedId2
                                ? 'left-document-align'
                                : 'right-document-align'
                            "
                            href="{{ baseDownloadUrl }}/{{
                              inverse.media.document
                            }}"
                          >
                            <a
                              href="{{ baseDownloadUrl }}/{{
                                inverse.media.document
                              }}"
                            >
                              <img
                                class="file-download-image"
                                src="../../../../assets/ic-download-file-image.svg"
                              />
                            </a>
                          </a>
                        </div>
                      </div>
                      <div
                        [ngClass]="
                          inverse.sender === receivedId2
                            ? 'left-align'
                            : 'right-align'
                        "
                        *ngIf="
                          inverse.message == '' &&
                          inverse.media.is_available == true &&
                          inverse.media.chat_pic != ''
                        "
                      >
                        <a
                          href="{{ baseDownloadUrl }}/{{
                            inverse.media.chat_pic
                          }}"
                        >
                          <img
                            class="download-image"
                            src="{{ baseDownloadUrl }}/{{
                              inverse.media.chat_pic
                            }}"
                            onerror="this.src='../../../../assets/ic-user.png'"
                        /></a>
                        <a
                          href="{{ baseDownloadUrl }}/{{
                            inverse.media.chat_pic
                          }}"
                        >
                          <img
                            class="file-download-image"
                            src="../../../../assets/ic-download-file-image.svg"
                          />
                        </a>
                      </div>
                      <div
                        [ngClass]="
                          inverse.sender === receivedId2
                            ? 'left-align'
                            : 'right-align'
                        "
                        *ngIf="
                          inverse.message == '' &&
                          inverse.media.is_available == true &&
                          inverse.media.chat_video != ''
                        "
                      >
                        <a
                          [ngClass]="
                            inverse.sender === receivedId2
                              ? 'left-align'
                              : 'right-align'
                          "
                          href="{{ baseDownloadUrl }}/{{
                            inverse.media.chat_video
                          }}"
                          >{{ inverse.media.video }} Download Video
                          <a
                            href="{{ baseDownloadUrl }}/{{
                              inverse.media.chat_video
                            }}"
                          >
                            <img
                              class="file-download-image"
                              src="../../../../assets/ic-download-file-image.svg"
                            />
                          </a>
                        </a>
                      </div>
                      <div
                        class="chat-message-time-container"
                        [ngClass]="
                          inverse.sender === receivedId2
                            ? 'date-left-align'
                            : 'date-right-align'
                        "
                      >
                        <p>{{ inverse.timestamp | date: "h:mm a" }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="chat-send-message-section"
                [ngClass]="{
                  'chat-change-section': messageContentExtender2 === true
                }"
              >
                <div class="chat-message-section">
                  <div class="chat-send-message-container">
                    <textarea
                      class="chat-text-area-section"
                      [(ngModel)]="content2"
                      placeholder="Type here..."
                      [ngClass]="{
                        'chat-text-area-container':
                          messageContentExtender2 === true
                      }"
                    ></textarea>
                    <button
                      class="chat-send-message-button"
                      (click)="
                        messageContentExtender2 = !messageContentExtender2
                      "
                    >
                      <!-- <div class="chat-window-minimizer"> -->
                      <img
                        class="updownslider"
                        *ngIf="messageContentExtender2"
                        src="../../../../assets/down_arrow_chat.png"
                        alt=""
                      />
                      <img
                        class="updownslider"
                        *ngIf="!messageContentExtender2"
                        src="../../../../assets/up_arrow_chat.png"
                        alt=""
                      />
                      <!-- </div> -->
                    </button>
                  </div>
                </div>
              </div>
              <div class="chat-message-clarify-section">
                <div class="chat-attachment-options">
                  <div
                    class="chat-image-send-video"
                    (click)="upload_document_file2.click()"
                  >
                    <input
                      type="file"
                      accept=".txt, text/plain,.doc,.docx, .csv, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      class="input-file"
                      #upload_document_file2
                      (change)="sendDocFile2($event)"
                    />
                    <img
                      class="chat-image-send-container"
                      src="../../../../assets/ic-document.svg"
                    />
                  </div>
                  <!-- <div class="chat-image-send-doc" (click)="upload_video_file2.click()">
                      <input type="file" accept="video/mp4,video/x-m4v,video/*" class="input-file" #upload_video_file2
                        (change)="sendVideoFile2($event)" />
                      <img class="chat-image-send-container" src="../../../../assets/ic-video.svg" />
                    </div> -->
                  <div
                    class="chat-image-send-doc"
                    (click)="upload_picture_file2.click()"
                  >
                    <input
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      class="input-file"
                      #upload_picture_file2
                      (change)="sendPicFile2($event)"
                    />
                    <img
                      class="chat-image-send-container"
                      src="../../../../assets/ic-picture.svg"
                    />
                  </div>
                </div>
                <div class="chat-send-message-container">
                  <button
                    class="chat-send-button"
                    [ngClass]="{ 'send-button-color': content2 !== '' }"
                    (click)="sendMsg2()"
                  >
                    send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-window2" *ngIf="openParticipants.length == 1">
        <div class="chat-window-content2" *ngIf="messages_loaded2">
          <div
            class="chat-window-header"
            [ngClass]="{
              'close-conversation-chat': participant_window2 === false
            }"
            (click)="openParticipantWindow2()"
          >
            <div class="chat-window-title-with-image">
              <div>
                <img
                  class="chat-window-participant-image"
                  src="{{ baseDownloadUrl }}/{{ participant_profile_picture1 }}"
                  onerror="this.src='../../../../assets/ic-user.png'"
                  alt="lN"
                />
              </div>
              <div class="chat-window-name-container">
                <span class="chat-window-participant-name">{{
                  participantName1 | titlecase
                }}</span>
                <span
                  class="chat-window-participant-time"
                  *ngIf="active_now1 == false"
                  >Last seen {{ last_seen1 }}</span
                >
                <div class="show-status-time">
                  <div [ngClass]="{ 'online-one': active_now1 === true }"></div>
                  <span class="active-now-status" *ngIf="active_now1 == true">
                    Active Now
                  </span>
                </div>
              </div>
            </div>
            <div class="chat-window-header-right">
              <div class="chat-window-closer" (click)="closeChat2()">
                <img
                  class="close-image-icon"
                  src="../../../../assets/chat-close.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div>
            <div *ngIf="participant_window2">
              <div
                class="chat-window-main-content"
                #message_container
                (scroll)="onScroll2($event)"
                [ngClass]="{ opened: messageContentExtender2 === true }"
              >
                <div class="message-spinner-container">
                  <mat-spinner
                    class="message-spinner"
                    [diameter]="30"
                    *ngIf="messageLoading2"
                  ></mat-spinner>
                </div>
                <div
                  class="message-group"
                  *ngFor="let inverse of secondWindowMessages; let i = index"
                >
                  <div
                    class="show-every-day-date"
                    *ngIf="inverse.show_timestamp == true"
                  >
                    <span class="show-differential-date">{{
                      inverse.timestamp | date: "d MMM, y"
                    }}</span>
                  </div>
                  <div>
                    <div
                      class="chat-message"
                      [ngClass]="
                        inverse.sender === receivedId2
                          ? 'left-align'
                          : 'right-align'
                      "
                    >
                      <div>
                        <span
                          class="chat-message-details"
                          *ngIf="inverse.message != ''"
                          >{{ inverse.message }}</span
                        >
                      </div>
                      <div
                        class="download-file-alignment"
                        [ngClass]="
                          inverse.sender === receivedId2 ? 'left-align' : ''
                        "
                        *ngIf="
                          inverse.message == '' &&
                          inverse.media.is_available == true &&
                          inverse.media.document != ''
                        "
                      >
                        <div class="document-line-alignment">
                          <a
                            href="{{ baseDownloadUrl }}/{{
                              inverse.media.document
                            }}"
                            class="document-name-change"
                            [ngClass]="
                              inverse.sender === receivedId2
                                ? 'left-doc-text'
                                : 'right-doc-text'
                            "
                            >{{ splitDocument(inverse.media.document) }}</a
                          >
                          <a
                            [ngClass]="
                              inverse.sender === receivedId2
                                ? 'left-document-align'
                                : 'right-document-align'
                            "
                            href="{{ baseDownloadUrl }}/{{
                              inverse.media.document
                            }}"
                          >
                            <a
                              href="{{ baseDownloadUrl }}/{{
                                inverse.media.document
                              }}"
                            >
                              <img
                                class="file-download-image"
                                src="../../../../assets/ic-download-file-image.svg"
                              />
                            </a>
                          </a>
                        </div>
                      </div>
                      <div
                        [ngClass]="
                          inverse.sender === receivedId2
                            ? 'left-align'
                            : 'right-align'
                        "
                        *ngIf="
                          inverse.message == '' &&
                          inverse.media.is_available == true &&
                          inverse.media.chat_pic != ''
                        "
                      >
                        <a
                          href="{{ baseDownloadUrl }}/{{
                            inverse.media.chat_pic
                          }}"
                        >
                          <img
                            class="download-image"
                            src="{{ baseDownloadUrl }}/{{
                              inverse.media.chat_pic
                            }}"
                            onerror="this.src='../../../../assets/ic-user.png'"
                          />
                          <a
                            href="{{ baseDownloadUrl }}/{{
                              inverse.media.chat_pic
                            }}"
                          >
                            <img
                              class="file-download-image"
                              src="../../../../assets/ic-download-file-image.svg"
                            />
                          </a>
                        </a>
                      </div>
                      <div
                        [ngClass]="
                          inverse.sender === receivedId2
                            ? 'left-align'
                            : 'right-align'
                        "
                        *ngIf="
                          inverse.message == '' &&
                          inverse.media.is_available == true &&
                          inverse.media.chat_video != ''
                        "
                      >
                        <a
                          [ngClass]="
                            inverse.sender === receivedId2
                              ? 'left-align'
                              : 'right-align'
                          "
                          href="{{ baseDownloadUrl }}/{{
                            inverse.media.chat_video
                          }}"
                          >{{ inverse.media.video }} Download Video
                          <a
                            href="{{ baseDownloadUrl }}/{{
                              inverse.media.chat_video
                            }}"
                          >
                            <img
                              class="file-download-image"
                              src="../../../../assets/ic-download-file-image.svg"
                            />
                          </a>
                        </a>
                      </div>
                      <div
                        class="chat-message-time-container"
                        [ngClass]="
                          inverse.sender === receivedId2
                            ? 'date-left-align'
                            : 'date-right-align'
                        "
                      >
                        <p>{{ inverse.timestamp | date: "h:mm a" }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="chat-send-message-section"
                [ngClass]="{
                  'chat-change-section': messageContentExtender2 === true
                }"
              >
                <div class="chat-message-section">
                  <div class="chat-send-message-container">
                    <textarea
                      class="chat-text-area-section"
                      [(ngModel)]="content2"
                      placeholder="Type here..."
                      [ngClass]="{
                        'chat-text-area-container':
                          messageContentExtender2 === true
                      }"
                    ></textarea>
                    <button
                      class="chat-send-message-button"
                      (click)="
                        messageContentExtender2 = !messageContentExtender2
                      "
                    >
                      <!-- <div class="chat-window-minimizer"> -->
                      <img
                        class="updownslider"
                        *ngIf="messageContentExtender2"
                        src="../../../../assets/down_arrow_chat.png"
                        alt=""
                      />
                      <img
                        class="updownslider"
                        *ngIf="!messageContentExtender2"
                        src="../../../../assets/up_arrow_chat.png"
                        alt=""
                      />
                      <!-- </div> -->
                    </button>
                  </div>
                </div>
              </div>
              <div class="chat-message-clarify-section">
                <div class="chat-attachment-options">
                  <div
                    class="chat-image-send-video"
                    (click)="upload_document_file2.click()"
                  >
                    <input
                      type="file"
                      accept=".txt, text/plain,.doc,.docx, .csv, application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      class="input-file"
                      #upload_document_file2
                      (change)="sendDocFile2($event)"
                    />
                    <img
                      class="chat-image-send-container"
                      src="../../../../assets/ic-document.svg"
                    />
                  </div>
                  <!-- <div class="chat-image-send-doc" (click)="upload_video_file2.click()">
                      <input type="file" accept="video/mp4,video/x-m4v,video/*" class="input-file" #upload_video_file2
                        (change)="sendVideoFile2($event)" />
                      <img class="chat-image-send-container" src="../../../../assets/ic-video.svg" />
                    </div> -->
                  <div
                    class="chat-image-send-doc"
                    (click)="upload_picture_file2.click()"
                  >
                    <input
                      type="file"
                      accept="image/png, image/gif, image/jpeg"
                      class="input-file"
                      #upload_picture_file2
                      (change)="sendPicFile2($event)"
                    />
                    <img
                      class="chat-image-send-container"
                      src="../../../../assets/ic-picture.svg"
                    />
                  </div>
                </div>
                <div class="chat-send-message-container">
                  <button
                    class="chat-send-button"
                    [ngClass]="{ 'send-button-color': content2 !== '' }"
                    (click)="sendMsg2()"
                  >
                    send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- <div class="progress-bar">
    <svg>
      <circle class="progress-circle-prog"
      [attr.r]="50" [attr.cx]="50" [attr.cy]="50"  ></circle>  </svg>
    <div class="progress-text">{{count}} / {{totalCount}}</div>
  </div> -->
<!--
  <div class="e one"></div>
  <div class="e two"></div>
  <div class="e three"></div>
  <div class="e four"></div>
  <div class="e five"></div> -->
<!-- <app-segment></app-segment> -->

<!-- <div class="fixed-parent">
    <div class="absolute-parent">
      <div>Window 1</div>
      <div>Window 2</div>
    </div>
  </div> -->
